module.exports = __webpack_public_path__ + "static/media/logo.cab5ec5a.jpeg";